import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import ListaTabla from './Includes/ListaTabla';
import ModalReclamaciones from './Includes/ModalReclamaciones';

import {ReclamacionesService} from '../../../services/_Sis/ReclamacionesService/ReclamacionesService';
import {FieldsJs} from "../../../settings/General/General";
import {ReactLocalStorageService} from '../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import VistaVacia from "../../Include/VistaVacia/VistaVacia";

import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../settings/IntegrationNotistack/IntegrationNotistack";
import {
	BotonActualizarLista,
	BotonExportarListaExcel,
	BotonExportarListaPDF,
	CabeceraTituloPdfExcelLista
} from "../../Include/MiniComponents/GlobalComponent";
import Paginacion from "../../Include/Paginacion/Paginacion";
import FiltrosReclamaciones from "./Includes/FiltrosReclamaciones";
import {HttpRequest} from "../../../settings/HttpRequest/HttpRequest";
import {CatService} from "../../../services/_Cat/CatService/CatService";


class Reclamaciones extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		this.state = {
			listar_reclamaciones: [],
			catalogos: [],
			
			filtro: {
				id_expediente: '',
				nombre: '',
				curp: '',
				rfc: '',
				id_cat_identificacion: '',
				fecha_ingreso: null,
				activo: 'all'
			},
			paginacion: {
				total: null,
				page: 1,
				limit: this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			},
		};
		this.Listar();
		this.Catalogos();
	}
	
	showSnackBars = (type, message) => {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	RefreshList = () => {
		this.Listar();
	};
	
	HandleFiltro = (filtro) => {
		this.setState({
			filtro: filtro
		});
	};
	
	DefaultNumPag = () => {
		let Cfg = ReactLocalStorageService.get('Cfg') || {};
		return Cfg.paginacion_numero_registro ? Number(Cfg.paginacion_numero_registro) : 10;
	};
	
	DefaultRangos = () => {
		let Cfg = ReactLocalStorageService.get('Cfg') || {};
		let rangos = [5, 10, 15, 20];
		if (FieldsJs.Array(Cfg.paginacion_rangos)) {
			rangos = Cfg.paginacion_rangos;
		}
		return rangos;
	};
	
	AplicarPaginacion = (data) => {
		let paginacion = this.state.paginacion;
		this.setState({
			paginacion: {
				total: paginacion.total || null,
				page: data.page || paginacion.page || null,
				limit: data.limit || paginacion.limit || this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			}
		});
		setTimeout(() => this.Listar());
	};
	
	AplicarFiltros = () => {
		let paginacion = this.state.paginacion;
		this.setState({
			paginacion: {
				total: paginacion.total || null,
				page: 1,
				limit: paginacion.limit || this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			}
		});
		setTimeout(() => this.Listar());
	};
	
	Listar = () => {
		ReclamacionesService.Listar(this.state.filtro, this.state.paginacion).then((response) => {
			this.setState({
				listar_reclamaciones: [],
				
				paginacion: {
					total: response.paginacion.total,
					page: response.paginacion.page,
					limit: response.paginacion.limit,
					rangos: this.DefaultRangos()
				}
			});
		}).catch((error) => {
			this.setState({
				listar_reclamaciones: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	Catalogos = (id_cat_entidad_federativa) => {
		CatService.ListReclamaciones(id_cat_entidad_federativa).then((response) => {
			this.setState({
				catalogos: response.data,
			});
		}).catch((error) => {
			this.setState({
				catalogos: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	catalogosEntidad = (id_cat_entidad_federativa) => {
		return new Promise((resolve, reject) => {
			CatService.ListReclamacionesMunicipio(id_cat_entidad_federativa).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	
	catalogosEntidadCodigoPostal = (id_cat_entidad_federativa, clave_municipio) => {
		return new Promise((resolve, reject) => {
			CatService.ListReclamacionesCodigoPostal(id_cat_entidad_federativa, clave_municipio).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	
	catalogosEntidadLocalidad = (id_cat_entidad_federativa, clave_municipio, clave_codigo_postal) => {
		return new Promise((resolve, reject) => {
			CatService.ListReclamacionesLocalidad(id_cat_entidad_federativa, clave_municipio, clave_codigo_postal).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	
	catalogosEntidadColonia = (id_cat_entidad_federativa, clave_municipio, clave_codigo_postal, clave_localidad) => {
		return new Promise((resolve, reject) => {
			CatService.ListReclamacionesColonia(id_cat_entidad_federativa, clave_municipio, clave_codigo_postal, clave_localidad).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	
	catalogosProductoServicio = (operacion, producto, tipo_credito) => {
		return new Promise((resolve, reject) => {
			CatService.ListReclamacionesProductoServicio(operacion, producto, tipo_credito).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	
	exportar = (item, archivo, auth) => {
		let filtro = {};
		
		HttpRequest.export('matriz_riesgo', ['matriz_riesgo'], {
			auth: auth,
			archivo: archivo,
			filtro: filtro
		}, false, false, false, archivo === "EXCEL")
	};
	
	render() {
		
		return (
			<div className='Catalogos ContaineViewComponet'>
				
				<CabeceraTituloPdfExcelLista
					titulo={'Reclamaciones'}
					botonLISTA={
						<Fragment>
							<div className={'v-center'}>
								<BotonActualizarLista onClick={() => {
									this.Listar();
								}}/>
							</div>
						</Fragment>
					}
					/*botonEXCEL={
						<Fragment>
							<div className={'v-center'}>
								<Fragment>
									<BotonExportarListaExcel onClick={() => this.exportar({}, 'EXCEL', true)}/>
								</Fragment>
							</div>
						</Fragment>
					}*/
				/>
				
				{/*<FiltrosExpedientes
					AplicarFiltros={this.AplicarFiltros}
					HandleFiltro={this.HandleFiltro}
					showSnackBars={this.showSnackBars}
				/>*/}
				
				<div className={'form margin-30-B margin-15-T'}>
					
					{this.state.listar_reclamaciones.length > 0 ? (
						<Fragment>
							<ListaTabla
								lista={this.state.listar_reclamaciones}
								RefreshList={this.RefreshList}
								showSnackBars={this.showSnackBars}
							/>
							<Paginacion
								total={this.state.paginacion.total}
								page={this.state.paginacion.page}
								limit={this.state.paginacion.limit}
								rangos={this.state.paginacion.rangos}
								onClick={(data) => this.AplicarPaginacion(data)}
							/>
						</Fragment>
					) : (
						<VistaVacia
							numero={0}
							mensaje={'No se encontraron datos.'}
						/>
					)}
				
				</div>
				
				<ModalReclamaciones
					tipo={'add'}
					item={{}}
					RefreshList={this.RefreshList}
					showSnackBars={this.showSnackBars}
					catalogos={this.state.catalogos}
					catalogosEntidad={this.catalogosEntidad}
					catalogosEntidadCodigoPostal={this.catalogosEntidadCodigoPostal}
					catalogosEntidadLocalidad={this.catalogosEntidadLocalidad}
					catalogosEntidadColonia={this.catalogosEntidadColonia}
					catalogosProductoServicio={this.catalogosProductoServicio}
				/>
			
			</div>
		);
	}
}

Reclamaciones.propTypes = {};

export default IntegrationNotistack(Reclamaciones);
